import Header from './header';

function Home() {
    return (
        <>
            <Header />
        </>
    );
}

export default Home;